
import InitialLoading from "@/components/InitialLoading.vue";
import LoadingPhases from "@/components/LoadingPhases.vue";
import ModalCodigo from "@/components/ModalCodigo.vue";
import "@/ts/Filters";
import Util from "@/ts/Util";
import axios from "axios";
import LoginFrontEnd, { LoginConfig } from "login-frontend";
import Orders from "orders-module";
import LoginModal from "shared-components/LoginModal.vue";
import tinycolor from "tinycolor2";
import vMoney from "v-money";
import { Component, Vue } from "vue-property-decorator";
import { SpecialRouter } from "./router";

declare var M: any;
declare var codePush: any;
declare var SyncStatus: any;
declare global {
  interface Window {
    opera: any;
  }
}
@Component({
  components: {
    LoadingPhases,
    InitialLoading,
    LoginModal,
    ModalCodigo,
  },
})
export default class App extends Vue {
  componentKey = 0;
  loginModal: any = LoginModal;
  nrorg: string = sessionStorage.getItem("INIT_NRORG") || "";
  decodePath = "";
  routeURI: any = undefined;
  lastRoute = JSON.parse(sessionStorage.getItem("LAST_ROUTE") || "{}");
  reloadRoute = "";
  reloadWindown = "";
  lp: any = LoadingPhases;
  blockDesk = false;
  version = 32800;
  cacheVersion: number = Number(sessionStorage.getItem("VERSION")) || 0;
  organizationData: any = JSON.parse(
    sessionStorage.getItem("ORGANIZATION_DATA") || "{}"
  );
  myDynamicManifest = {
    name: this.organizationData.NICK_NAME || this.organizationData.NAME,
    short_name: this.organizationData.NICK_NAME || this.organizationData.NAME,
    description: "Aplicativo Eattake",
    theme_color: this.organizationData.CONFIGURATIONS.PRIMARY_COLOR,
    icons: [
      {
        src:
          this.organizationData.CONFIGURATIONS.LOGO_IMAGE_SMALL ||
          "https://posto-xapa.s3.amazonaws.com/7D3AEEFC-A13E-",
        sizes: "144x144",
        type: "image/png",
        purpose: "any",
      },
      {
        src:
          this.organizationData.CONFIGURATIONS.LOGO_IMAGE_SMALL ||
          "https://posto-xapa.s3.amazonaws.com/7D3AEEFC-A13E-",
        sizes: "144x144",
        type: "image/png",
        purpose: "maskable",
      },
      {
        src:
          this.organizationData.CONFIGURATIONS.LOGO_IMAGE_SMALL ||
          "https://posto-xapa.s3.amazonaws.com/7D3AEEFC-A13E-",
        sizes: "192x192",
        type: "image/png",
      },
      {
        src:
          this.organizationData.CONFIGURATIONS.LOGO_IMAGE_SMALL ||
          "https://posto-xapa.s3.amazonaws.com/7D3AEEFC-A13E-",
        sizes: "512x512",
        type: "image/png",
      },
    ],
    start_url: window.location.origin,
    display: "standalone",
    background_color: "#ffffff",
  };
  inactivityTimer = 0;
  showLogoutModal = false;
  showLogoutTimer: number | undefined = undefined;
  logoutTimer: number | undefined = undefined;
  remainingTime = 10;
  decreaseRemainingTimeInterval: number | undefined = undefined;
  showModalLogoff = false;
  showModalStoreNotFound = false;
  showInitialLoading = true;

  created() {
    if (!this.organizationData) {
      this.showModalStoreNotFound = true;
    }
    this.confDynamicManifest();
    if (this.isPageReloaded()) this.showInitialLoading = false;
    else setTimeout(() => (this.showInitialLoading = false), 3000);
  }

  mounted() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (userAgent.toLowerCase().includes("instagram")) {
      if (sessionStorage.getItem("reloaded")) {
        // The page was just reloaded. Clear the value from local storage
        // so that it will reload the next time this page is visited.
        sessionStorage.removeItem("reloaded");
      } else {
        // Set a flag so that we know not to reload the page twice.
        sessionStorage.setItem("reloaded", "1");
        location.reload();
      }
    }
    Util.ajustWindow();
    if (this.blockDesk) {
      if (this.detectar_mobile() == false) {
        sessionStorage.setItem("MOBILE", "false");
        this.lp.start(
          this.lp.ERROR,
          "Favor, utilize uma plataforma mobile para acessar o sistema."
        );
      }
    }
    if (sessionStorage.getItem("PROVIDER")) {
      this.lp.start(this.lp.SUCCESS, "Login efetuado com sucesso!");
    }
    this.reloadLocation();

    const fullPath = window.location.href;
    let [pathBeforeHash, hashPath] = fullPath.split("#");

    this.routeURI = undefined;

    if (hashPath && hashPath.includes("/")) {
      this.routeURI = hashPath.split("/").filter(Boolean).pop();
    }

    if (!this.routeURI) {
      let pathWithoutDomain = new URL(pathBeforeHash).pathname;
      this.routeURI = pathWithoutDomain.split("/").filter(Boolean).pop();
    }

    if (this.routeURI) {
      let fixedUrl = `${window.location.origin}/#/${this.routeURI}`;
      window.history.replaceState(null, "", fixedUrl);
    }

    Orders.addRoutes();
    LoginFrontEnd.addRoutes();

    if (
      this.routeURI &&
      this.isBase64(this.routeURI) &&
      this.routeURI !== "" &&
      !this.isValidRoute(this.routeURI)
    ) {
      this.decodePath = atob(this.routeURI);
      sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(true));
    } else {
      if (!sessionStorage.getItem("QRCODE")) {
        sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(false));
      }
    }

    this.loginModal.setLoginProps({
      loginMethods: ["CPF"],
      loginMessage: "Olá! ",
      loginMessageHighLight: "Seja bem-vindo.",
      loginLogo: "xappa.png",
      loginCallback: this.goHome,
      loginRegisterMessage: "Preencha os campos abaixo para ",
      loginRegisterMessageHighlight: "realizar seu cadastro.",
      nrorg: this.nrorg,
      backgroundImage: "celebrate.jpg",
    });
    Vue.use(vMoney);
    document.addEventListener("deviceready", this.syncCodePush);
    document.addEventListener("resume", this.syncCodePush);
    document.addEventListener("click", this.refreshLogoutTime, true);
    document.addEventListener(
      "keypress",
      this.refreshLogoutTimeOnKeyPress,
      true
    );

    const useIntegration = sessionStorage.getItem("USE_INTEGRATION") || "";
    const userData = JSON.parse(sessionStorage.getItem("USER_DATA") || "{}");

    if (useIntegration === "") {
      axios.all([Util.getUseIntegration()]).then((response: any) => {
        const useIntegration = response[0].data.dataset.response.useIntegration;
        sessionStorage.setItem("USE_INTEGRATION", String(useIntegration));
        this.start(useIntegration);
      });
    } else if (
      sessionStorage.getItem("CAME_FROM_LOGIN") === "false" &&
      sessionStorage.getItem("USER_ID") &&
      sessionStorage.getItem("TOKEN") &&
      userData.ID
    ) {
      let homeLayout = this.verifyRouteHome();
      this.$router.push(homeLayout);
    } else {
      const useIntegration =
        sessionStorage.getItem("USE_INTEGRATION") === "true" ? true : false;
      this.start(useIntegration);
    }

    let organizationData = JSON.parse(
      sessionStorage.getItem("ORGANIZATION_DATA") || "{}"
    );

    if (organizationData.CONFIGURATIONS) {
      const rootStyle = document.documentElement.style;

      if (rootStyle) {
        rootStyle.setProperty(
          "--primary-color",
          organizationData.CONFIGURATIONS.PRIMARY_COLOR
        );
        rootStyle.setProperty(
          "--secundary-color",
          organizationData.CONFIGURATIONS.SECONDARY_COLOR
        );
        rootStyle.setProperty(
          "--primary-color-light",
          tinycolor(organizationData.CONFIGURATIONS.PRIMARY_COLOR)
            .lighten(35)
            .toHexString()
        );
        rootStyle.setProperty(
          "--support-color",
          organizationData.CONFIGURATIONS.SUPPORT_COLOR
        );
        rootStyle.setProperty(
          "--secundary-support-color",
          organizationData.CONFIGURATIONS.SUPPORT_COLOR
        );
      }
    }
    this.setThemeColor(organizationData.CONFIGURATIONS.PRIMARY_COLOR);
    if (sessionStorage.getItem("USER_ID")) {
      Util.getFidelityProgram();
    }
  }

  setThemeColor(color: string) {
    let theme = document.querySelector<HTMLMetaElement>(
      "meta[name=theme-color]"
    );
    if (!theme) {
      theme = document.createElement("meta");
      theme.name = "theme-color";
      document.head.appendChild(theme);
    }
    theme.setAttribute("content", color);
  }

  confDynamicManifest() {
    const stringManifest = JSON.stringify(this.myDynamicManifest);
    const blob = new Blob([stringManifest], { type: "application/json" });
    const manifestURL = URL.createObjectURL(blob);
    let dynamicManifest = document.querySelector("#dynamic-manisfest");
    if (dynamicManifest != null)
      dynamicManifest.setAttribute("href", manifestURL);
  }

  syncCodePush() {
    //if (process.env.NODE_ENV === "production") {
    codePush.notifyApplicationReady();
    let message = "";
    if (typeof codePush !== "undefined")
      codePush.sync((status: any) => {
        if (typeof SyncStatus !== "undefined") {
          if (status === SyncStatus.UPDATE_INSTALLED)
            message =
              "A atualização será concluída após a aplicação ser reiniciada";
          else if (status === SyncStatus.DOWNLOADING_PACKAGE)
            message = "Baixando atualização";
          else if (status === SyncStatus.INSTALLING_UPDATE)
            message = "Instalando atualização";

          if (message) M.toast({ html: message, displayLength: 1500 });
        }
      });
    //}
  }

  start(useIntegration: boolean) {
    if (useIntegration) {
      this.$router.push("/BeginningCreatePassword");
    } else {
      LoginFrontEnd.start(
        new LoginConfig(
          ["CPF"],
          "Olá! ",
          "Seja bem-vindo.",
          "xappa.png",
          this.goHome,
          "Preencha os campos abaixo para ",
          "realizar seu cadastro.",
          this.nrorg,
          "celebrate.jpg"
        )
      );
    }
  }

  userIsLogged() {
    return sessionStorage.getItem("USER_ID") && sessionStorage.getItem("TOKEN");
  }

  async goHome() {
    let organizationData = JSON.parse(
      sessionStorage.getItem("ORGANIZATION_DATA") || "{}"
    );

    let patchExistsOnRouters = true;
    if (this.routeURI) {
      const normalizedRoute = this.routeURI.startsWith("/")
        ? this.routeURI
        : `/${this.routeURI}`;
      patchExistsOnRouters =
        SpecialRouter.guestRoutes.includes(normalizedRoute) ||
        normalizedRoute == "/PedidosRealizados" ||
        normalizedRoute == "/About" ||
        normalizedRoute == "/Surveys" ||
        normalizedRoute == "/Survey" ||
        normalizedRoute == "/PaymentMethod" ||
        normalizedRoute == "/ExtratoPedido" ||
        normalizedRoute == "/ChooseVoucher" ||
        normalizedRoute == "/PagamentoPix" ||
        normalizedRoute.includes("digitalMenu");
    }

    sessionStorage.removeItem("QRCODE");
    let homeLayout = this.verifyRouteHome();
    const reloadDigitalMenu =
      (this.$route.query && this.$route.query.digitalMenu) ||
      (this.lastRoute &&
        this.lastRoute.query &&
        this.lastRoute.query.digitalMenu);
    if (reloadDigitalMenu) {
      sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(true));
      sessionStorage.setItem("SHOW_BUTTONS", JSON.stringify(false));
    } else {
      sessionStorage.setItem("SHOW_BUTTONS", JSON.stringify(true));
    }

    if (homeLayout === "HomeLojas") {
      sessionStorage.setItem("USE_CURRENT_LOCATION", "false");
    }

    if (this.decodePath !== "") {
      Util.decodePathRoute(this.decodePath);
    } else if (this.lastRoute && this.reloadRoute === "Produtos") {
      reloadDigitalMenu
        ? this.$router.push({
            name: this.lastRoute.name,
            params: this.lastRoute.params,
            query: { digitalMenu: "true" },
          })
        : this.$router.push(this.lastRoute);
    } else if (!patchExistsOnRouters && this.routeURI && this.routeURI != "") {
      const sucessDecodeStoreName = await Util.decodeStoreNamePathRoute(
        this.routeURI,
        organizationData.NRORG
      );
      if (!sucessDecodeStoreName) {
        this.showModalStoreNotFound = true;
        setTimeout(() => this.goBack(), 60000);
      }
    } else if (this.$route.path !== "/") {
      if (this.$route.path !== "/" + this.reloadRoute)
        reloadDigitalMenu
          ? this.$router.push({
              name: this.reloadRoute,
              params: this.lastRoute.params,
              query: { digitalMenu: "true" },
            })
          : this.$router.push(this.reloadRoute);
    } else {
      sessionStorage.setItem("SHOW_BACKBUTTON", JSON.stringify(true));
      this.$router.push(homeLayout);
    }
  }

  goBack() {
    let homeLayout = this.verifyRouteHome();
    this.showModalStoreNotFound = false;
    this.$router.push(homeLayout);
  }

  isBase64(str: string) {
    const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;
    if (!base64Regex.test(str) || str.length % 4 !== 0) {
      return false;
    }

    try {
      const decoded = atob(str);
      // eslint-disable-next-line no-control-regex
      return /^[\x00-\x7F]*$/.test(decoded);
    } catch (e) {
      return false;
    }
  }

  isValidRoute(str: string) {
    let l = this.$router.resolve({ name: str });
    if (l.resolved.matched.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  reloadLocation() {
    let oneMinute = 60000;
    setInterval(() => {
      if (sessionStorage.getItem("LATITUDE")) {
        let latitude;
        let longitude;
        navigator.geolocation.getCurrentPosition(
          (location: any) => {
            latitude = location.coords.latitude;
            longitude = location.coords.longitude;
            sessionStorage.setItem("LATITUDE", latitude);
            sessionStorage.setItem("LONGITUDE", longitude);
          },
          console.error,
          { timeout: 10000 }
        );
      }
    }, oneMinute * 15);
  }

  verifyRouteHome() {
    let homeLayout: any = Util.verifyRouteHome();
    return homeLayout;
  }

  detectar_mobile() {
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    } else {
      return false;
    }
  }

  refreshLogoutTimeOnKeyPress(event: any) {
    const keyName = event.key;
    if (keyName === "Enter") this.refreshLogoutTime();
  }

  clearTimeoutTimer() {
    this.inactivityTimer = 15;
    this.showLogoutModal = false;
    clearTimeout(this.showLogoutTimer);
    this.showLogoutTimer = undefined;
    clearTimeout(this.logoutTimer);
    this.logoutTimer = undefined;
    clearInterval(this.decreaseRemainingTimeInterval);
    this.decreaseRemainingTimeInterval = undefined;
    this.remainingTime = 30;
  }

  refreshLogoutTime(event: any = undefined) {
    if (
      event !== undefined &&
      typeof event.target.className != "object" &&
      event.target.className.includes("btn-logout")
    ) {
      this.clearTimeoutTimer();
      return;
    }
    if (sessionStorage.getItem("USER_ID") == "") {
      this.clearTimeoutTimer();
      return;
    }
    this.clearTimeoutTimer();
    if (this.showLogoutTimer === undefined) {
      if (this.inactivityTimer > 0) {
        this.showLogoutTimer = setTimeout(
          this.openLogoutModal,
          60000 * this.inactivityTimer
        );
      }
    }
  }

  openLogoutModal() {
    clearTimeout(this.showLogoutTimer);
    this.showLogoutTimer = undefined;
    clearTimeout(this.logoutTimer);
    this.logoutTimer = undefined;
    clearInterval(this.decreaseRemainingTimeInterval);
    this.decreaseRemainingTimeInterval = undefined;
    if (this.logoutTimer === undefined) {
      this.showLogoutModal = true;
      if (this.decreaseRemainingTimeInterval === undefined)
        this.decreaseRemainingTimeInterval = setInterval(
          () => this.decreaseRemainingTime(),
          1000
        );
      this.logoutTimer = setTimeout(this.logoutUserAndGoToHome, 30000);
    } else {
      this.showLogoutTimer = setTimeout(this.openLogoutModal, 30000);
      this.syncCodePush();
    }
  }

  decreaseRemainingTime() {
    this.remainingTime -= 1;
  }

  logoutUserAndGoToHome() {
    this.showModalLogoff = true;
    Util.logOff();
  }

  isPageReloaded() {
    const reloadFlag = sessionStorage.getItem("pageReloaded");
    if (reloadFlag) return true;
    else {
      sessionStorage.setItem("pageReloaded", "true");
      return false;
    }
  }
}
